// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app." + {"792":"7c5da90a53174d7a7718","816":"345a03d8633ff820e1fc"}[chunkId] + ".css";
};